import axiosInstance from "../../../../interceptors/axiosInstance";
import { RowCorreccionMonetaria } from "../models/rowCorreccionMonetaria";
import { UpsertMesAnteriorInterface } from '../models/UpsertMesAnterior';

const upsertMesAnterior = async (row: UpsertMesAnteriorInterface) => {
    const response: Promise<any> = axiosInstance.post(`siscred-api-maestros/v1/correccionmonetaria/upsertmesanterior`, {...row});
    return response;
}

const deleteMesAnterior = async (row: RowCorreccionMonetaria) => {
    const headers = {
        'X-Hide-Toast': 'true',
        "X-Hide-Loader" : 'true',
    };
    
    const response: Promise<any> = axiosInstance.delete(`siscred-api-maestros/v1/correccionmonetaria/deletemesanterior/${row.anno}/12/${row.numero}`, { headers });
    return response;
};

export {
    upsertMesAnterior,
    deleteMesAnterior
};


